export default __webpack_public_path__ + "static/media/Loader.e6927d07.gif";